import { render, staticRenderFns } from "./PageCoreValues.vue?vue&type=template&id=ca0b6328&"
import script from "./PageCoreValues.vue?vue&type=script&lang=js&"
export * from "./PageCoreValues.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports